import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const MAPPING_FIELDS = [
  { key: "order_id", label: "Order number", required: true },
  { key: "email", label: "Customer email" },
  { key: "full_name", label: "Customer full name" },
  { key: "first_name", label: "First name" },
  { key: "last_name", label: "Last name" },
  { key: "order_date", label: "Order date", required: true },
  { key: "total", label: "Order total", required: true },
  { key: "subtotal", label: "Subtotal" },
  { key: "shipping", label: "Shipping" },
  { key: "tax", label: "Tax" },
  { key: "discount", label: "Discount" },
  { key: "status", label: "Payment status" },
  { key: "refund_amount", label: "Refund amount" },
  { key: "item_name", label: "Product name" },
  { key: "item_quantity", label: "Quantity" },
  { key: "item_price", label: "Unit price" },
  { key: "item_sku", label: "SKU" },
  { key: "phone", label: "Phone" },
  { key: "street", label: "Billing street" },
  { key: "city", label: "Billing city" },
  { key: "state", label: "Billing state" },
  { key: "zip", label: "Billing ZIP code" },
  { key: "country", label: "Billing country" },
  { key: "ship_street", label: "Shipping street" },
  { key: "ship_city", label: "Shipping city" },
  { key: "ship_state", label: "Shipping state" },
  { key: "ship_zip", label: "Shipping ZIP code" },
  { key: "ship_country", label: "Shipping country" },
];

export const MappingStep = ({ headers, mapping, setMapping, templates, templateName, setTemplateName, busy, onApply, onReset }) => (
  <Card className="shadow-sm fade-in" data-testid="mapping-panel">
    <CardContent className="p-8 space-y-6">
      <div>
        <h2 className="text-2xl font-serif font-semibold">Match the columns</h2>
        <p className="text-sm text-muted-foreground mt-1">Tell us which column in your file holds each piece of information. Fields marked * are required.</p>
      </div>
      {templates.length > 0 && (
        <div className="space-y-1.5 max-w-xs">
          <Label>Use a saved template</Label>
          <Select onValueChange={(id) => { const t = templates.find((x) => x.id === id); if (t) setMapping(t.mapping); }}>
            <SelectTrigger data-testid="template-select"><SelectValue placeholder="Choose a template" /></SelectTrigger>
            <SelectContent>{templates.map((t) => <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      )}
      <div className="grid sm:grid-cols-2 gap-x-8 gap-y-3">
        {MAPPING_FIELDS.map((f) => (
          <div key={f.key} className="flex items-center justify-between gap-3">
            <span className="text-sm">{f.label}{f.required && <span className="text-destructive"> *</span>}</span>
            <Select
              value={mapping[f.key] || "__none"}
              onValueChange={(v) => setMapping({ ...mapping, [f.key]: v === "__none" ? "" : v })}
            >
              <SelectTrigger className="w-48" data-testid={`mapping-${f.key}`}><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="__none">— skip —</SelectItem>
                {headers.map((h) => <SelectItem key={h} value={h}>{h}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap items-end gap-3 pt-2 border-t border-border">
        <div className="space-y-1.5">
          <Label>Save this layout for next time (optional)</Label>
          <Input placeholder="e.g. PayPal monthly export" value={templateName} onChange={(e) => setTemplateName(e.target.value)} data-testid="template-name-input" />
        </div>
        <Button onClick={onApply} disabled={busy} data-testid="apply-mapping-btn">{busy ? "Checking…" : "Continue to preview"}</Button>
        <Button variant="ghost" onClick={onReset}>Start over</Button>
      </div>
    </CardContent>
  </Card>
);
